export default __webpack_public_path__ + "static/media/LogoWhiteBG.ce713af2.png";